
import React from 'react';
import { Target, Eye, Award } from 'lucide-react';
import Reveal from '../components/Reveal';
import SEO from '../components/SEO';
import './About.css';

const About = () => {
  return (
    <div className="about-page">
      <SEO 
        title="About Us | Sotak Investment & Property" 
        description="Learn about Sotak's legacy of excellence in real estate, property management, and strategic investments."
      />
      <section className="page-header about-header">
        <div className="container">
          <Reveal>
            <h1>About Sotak</h1>
            <p>Building legacy through integrity and innovation.</p>
          </Reveal>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="about-grid">
            <div className="about-content">
              <Reveal>
                <h4 className="subtitle">Our Story</h4>
                <h2>A Legacy of Excellence</h2>
                <p>
                  Founded with a vision to revolutionize the investment and property landscape, 
                  Sotak Investment and Property Company Ltd has grown into a multi-sector powerhouse. 
                  Our journey is defined by a relentless pursuit of quality and a deep commitment to 
                  our clients' success.
                </p>
                <p>
                  We operate across diverse sectors including real estate development, property management, 
                  building construction, general contracts, and strategic investments. This multidisciplinary 
                  approach allows us to offer comprehensive solutions that drive value and growth.
                </p>
              </Reveal>
            </div>
            <div className="about-stats-image">
               <Reveal delay={200}>
                 <img src="/images/interior10.jpeg" alt="Office Interior" />
               </Reveal>
            </div>
          </div>
        </div>
      </section>

      <section className="section section-grey">
        <div className="container">
          <div className="values-grid">
            <Reveal delay={100} className="value-card">
              <Target size={40} className="value-icon" />
              <h3>Our Mission</h3>
              <p>To deliver superior investment and property solutions that create lasting value for our stakeholders through innovation and integrity.</p>
            </Reveal>
            <Reveal delay={300} className="value-card">
              <Eye size={40} className="value-icon" />
              <h3>Our Vision</h3>
              <p>To be the leading global partner in real estate and investment services, recognized for our commitment to excellence and sustainable development.</p>
            </Reveal>
            <Reveal delay={500} className="value-card">
              <Award size={40} className="value-icon" />
              <h3>Core Values</h3>
              <ul className="values-list">
                <li>Integrity</li>
                <li>Excellence</li>
                <li>Innovation</li>
                <li>Customer Focus</li>
              </ul>
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
